import Vue from 'vue';
//import operatingpointAPI from '/home/vagrant/HeliosLaravelProjects/HeliosSelect/resources/js/components/services/api/operatingpointAPI.js';

import operatingpointAPI from '../../components/services/api/operatingpointAPI.js'

// local state
const getDefaultState = () => {
    return {
        loaded:'',
        op: {
            airflow: '',
            pressure: '',
            airflowunits: 1,
            airflowunits_options: [
                { value: 1, text: 'm³/h' },
                { value: 2, text: 'm³/s' },
                { value: 3, text: 'l/s' },
                { value: 4, text: 'cfm' }
            ],
            pressureunits: 5,
            pressureunits_options: [
                { value: 5, text: 'Pa' },
                { value: 6, text: 'N/m²' },
                { value: 7, text: 'mmwg' },
                { value: 8, text: 'inwg' }
            ],
            pressuretype: 'stat',
            pressuretype_options: [
                { value: 'stat', text: 'static' },
                { value: 'tot', text: 'total' },
            ],
            airflow_deviation: [-20, 20],
            pressure_deviation: [-20, 20],
            units: [],
            maxdba: ''
        },
        selectedCategories: [],
        descselectedCategories: [],
        selectedTmpCategories: [],
        table_fields_fans: [
            { key: 'ref_no', label: 'lang.short.ref_no' },
            { key: 'type', label: 'lang.short.type' },
            { key: 'dimension', label: 'lang.units.mm' },
            { key: 'rpm', label: 'lang.short.rpm' },
            { key: 'volumeflow', label: 'lang.units.airflow_volume' },
            { key: 'pressure', label: 'lang.units.pressure' },
            { key: 'elpower', label: 'lang.units.kilowatt' },
            { key: 'max_dba', label: 'lang.global.product.tabs.techdata.acoustic.dba'},
           /* { key: 'price', label: 'lang.global.price' },*/
            { key: 'prodgroup', label: 'lang.short.wg'},
            { key: 'delivery', label: 'lang.global.product.tabs.techdata.delivery'},
            { key: 'shoppingcart', label: '' },
            { key: 'info', label: 'lang.long.details' },
        ],
        resultlist_products: [],
        resultlist_categories: [],
        product_data: [],
        search: {
            keyword: '',
            archive: 0
        },
        table_fields_accessories: [
            { key: 'ref_no', label: 'lang.short.ref_no' },
            { key: 'type', label: 'lang.short.type' },
            { key: 'description_short', label: 'lang.global.product.tabs.techdata.desc_short' },
           /* { key: 'price', label: 'lang.global.price' },*/
            { key: 'prodgroup', label: 'lang.short.wg' },
            { key: 'shoppingcart', label: '' },
            { key: 'info', label: 'lang.long.details' },
        ],
        //for shopping cart settings:
        user_settings: {
            country_price: 1,
            difference: 10,
            discount_1: 0,
            discount_2: 0,
            freight_position: '',
            languages_id: 1,
            newsletter: 0,
            note: '',
            pressure: 5,
            pressure_type: 9,
            user_profiles_id: '',
            vat: 19,
            volume_flow: 1
        },
        categories: [],
        actionarealoaded: '',
    }
};

const state = getDefaultState();



const getters = {
   /*  getUnits(state) {
        return state.airflowunits;
    },
 */
};
const mutations = {
    /*setUnits(state, units) {
        //handle success
        state.op.airflowunits_options = []
        state.op.pressureunits_options = []
        for (var i = 0; i < units.length; i++) {
            if (units[i].unit_types_id == 1) {
                state.op.airflowunits_options.push({ value: units[i].id, text: units[i].label });
                if (units[i].is_base == true) state.op.airflowunits = units[i].id;
            }
            else if (units[i].unit_types_id == 2) {
                state.op.pressureunits_options.push({ value: units[i].id, text: units[i].label });
                if (units[i].is_base == true) state.op.pressureunits = units[i].id;
            }
        }
    },
    */
    setSettings(state, payload) {

        state.op.airflowunits_options = []
        state.op.pressureunits_options = []
        state.op.pressuretype_options = []

        /*  ToDo for globals  '/api/get/users/settings/data'; //returnTotalUserData */
        for (var i = 0; i < payload.units.length; i++) {
            if (payload.units[i].name == 'volume_flow') {
                for (var j = 0; j < payload.units[i].units.length; j++) {
                    state.op.airflowunits_options.push({ value: payload.units[i].units[j].id, text: payload.units[i].units[j].label });
                    if (payload.units[i].units[j].is_base == true) state.op.airflowunits = payload.units[i].units[j].id;
                }
            }
            else if (payload.units[i].name == 'pressure') {
                for (var j = 0; j < payload.units[i].units.length; j++) {
                    state.op.pressureunits_options.push({ value: payload.units[i].units[j].id, text: payload.units[i].units[j].label });
                    if (payload.units[i].units[j].is_base == true) state.op.pressureunits = payload.units[i].units[j].id;
                }
            }
            else if (payload.units[i].name == 'pressure_type') {
                for (var j = 0; j < payload.units[i].units.length; j++) {
                    state.op.pressuretype_options.push({ value: payload.units[i].units[j].id==10?'tot':'stat', text: payload.units[i].units[j].label });
                    if (payload.units[i].units[j].is_base == true) state.op.pressuretype = payload.units[i].units[j].id == 10 ? 'tot' : 'stat';
                }
            }

        }
        /*for  globals '/api/get/users/settings';  //without units
        var airflowunits_options = payload.units.filter(u => u.unit_types_id==1)
        for (var i = 0; i < airflowunits_options.length; i++) {
            state.op.airflowunits_options.push({ value: airflowunits_options[i].id, text: airflowunits_options[i].label });
            if (airflowunits_options[i].is_base == true) state.op.airflowunits = airflowunits_options[i].id;
        }
        var pressureunits_options = payload.units.filter(u => u.unit_types_id == 2)
        for (var i = 0; i < pressureunits_options.length; i++) {
            state.op.pressureunits_options.push({ value: pressureunits_options[i].id, text: pressureunits_options[i].label });
            if (pressureunits_options[i].is_base == true) state.op.pressureunits = pressureunits_options[i].id;
        }
        var pressuretype_options = payload.units.filter(u => u.unit_types_id == 3)
        for (var i = 0; i < pressuretype_options.length; i++) {
            state.op.pressuretype_options.push({ value: pressuretype_options[i].id == 10 ? 'tot' : 'stat', text: pressuretype_options[i].label });
            if (pressuretype_options[i].is_base == true) state.op.pressuretype = pressuretype_options[i].id;
        }
        */
/*
        console.log('OpreratingPoint setSettings payload.user_settings ')
        console.log( payload.user_settings)*/


        if (payload.user_settings.length > 0) {
            state.op.airflowunits = payload.user_settings[0].volume_flow;
            state.op.pressureunits = payload.user_settings[0].pressure;

            state.op.airflow_deviation = [payload.user_settings[0].difference * (-1), payload.user_settings[0].difference];
            state.op.pressure_deviation = [payload.user_settings[0].difference * (-1), payload.user_settings[0].difference];

            if (payload.user_settings[0].pressure_type == 10) state.op.pressuretype = 'tot';
            else state.op.pressuretype = 'stat';

            //for shopping cart settings discount, vat,...
            state.user_settings = payload.user_settings[0];
           /* console.log('payload.user_settings after set')
            console.log(state.op.airflowunits)*/



        }
    },

    setDefaults(state, units) {
        //console.log('OP setDefaults')

        //handle success
        state.op.airflow=''
        state.op.pressure= ''
        state.maxdba= ''
        state.selectedCategories = []
        state.selectedTmpCategories = []
        state.descselectedCategories = []
        state.descselectedCategories = []


        state.op.airflowunits_options = []
        state.op.pressureunits_options = []
        state.op.pressuretype_options = []

        //state.op.units = units //all units



        for (var i = 0; i < units.length; i++) {
            if (units[i].unit_types_id == 1) {
                state.op.airflowunits_options.push({ value: units[i].id, text: units[i].label });
                if (units[i].is_base == true) state.op.airflowunits = units[i].id;
            }
            else if (units[i].unit_types_id == 2) {
                state.op.pressureunits_options.push({ value: units[i].id, text: units[i].label });
                if (units[i].is_base == true) state.op.pressureunits = units[i].id;
            }
            else if (units[i].unit_types_id == 3) {
                state.op.pressuretype_options.push({ value: units[i].id == 10 ? 'tot' : 'stat' , text: units[i].label });
                if (units[i].is_base == true) state.op.pressuretype = units[i].id == 10 ? 'tot' : 'stat';
            }
        }

        state.op.units = units //all units

        console.log('setDefaults state.op.units: ')
        console.log(units)


        state.op.airflow_deviation = [-20, 20];
        state.op.pressure_deviation = [-20, 20];
        state.loaded = 1;
       /*  console.log('setDefaults deviation')
        console.log(state.op.airflow_deviation)
        console.log(state.op.pressure_deviation)  */


    },
   /*  setPressuretypeOptions(state, payload) {
        state.op.pressuretype_options = payload;
    }, */
    updateloaded(state, payload) {
        state.loaded = payload;
    },
    updateairflow(state, payload) {
        state.op.airflow = payload;
        console.log('updateairflow')
        console.log(state.op.airflow)
    },
    updatepressure(state, payload) {
        state.op.pressure = payload;
    },
    updatepressuretype(state, payload) {
        state.op.pressuretype = payload;
    },
    updateairflowdeviation(state, payload) {
        state.op.airflow_deviation = payload;
    },
    updatepressuredeviation(state, payload) {
        state.op.pressure_deviation = payload;
    },

    updateairflowunits(state, payload) {
        console.log('updateairflowunits')
        state.op.airflowunits = payload;
    },
    updatepressureunits(state, payload) {
        console.log('updatepressureunits')
        state.op.pressureunits = payload
    },
    updateSelectedCategories(state, categories) {
        console.log('updateSelectedCategories', categories)
        state.selectedCategories = categories
    },
    updateSelectedTmpCategories(state, categories) {
        console.log('updateSelectedTmpCategories')
        console.log(categories)
        state.selectedTmpCategories = categories
    },
    updateResultListProducts(state, resultlist) {
        /* console.log('bin in updateResultListProducts:');
        console.log(resultlist); */
        state.resultlist_products = resultlist
    },
    updateResultListCategories(state, resultlist) {
      /*   console.log('bin in updateResultListCategories:');
        console.log(resultlist); */
        state.resultlist_categories = resultlist
    },
    updateop(state, payload) {
        console.log('bin in OperatingPoint updateop:');
        console.log(payload);
        state.op = payload;
    },
    updatesearch(state, payload) {
        /* console.log('bin in updatesearch:');
        console.log(payload); */
        state.search = payload;
    },
    setDescSelectedCategories(state, cats_desc) {
        state.descselectedCategories = cats_desc
    },
    setCategories(state, categories) {
        state.categories = categories
        console.log('setCategories:', state.categories)
    },
   /*  updateactionarealoaded(state, payload) {
        state.actionarealoaded = payload
    },  */



    resetState(state) {
        Object.assign(state, getDefaultState())
    },



};
//
const actions = {
    //data : user
    async InitLoad({ commit }, data) {
        var units
        console.log('OP InitLoad:')

    /* !!! zum testen auskommentiert
        var response = await operatingpointAPI.getUnits()
        var units = response.data
        if(response.status >= 400) {
            console.log('Fehler operatingpointAPI.getUnits');
        }
        else commit('setDefaults', response.data);
    */


       /*  operatingpointAPI.getUnits()
            .then(response => {
                //ToDo units are together with settings from getUserSettings
                console.log('operatingpoint InitLoad in getUnits');
                console.log(response);
                units = response.data
                console.log('operatingpoint unitsfsdfsfs');
                console.log(units);
                commit('setDefaults', response.data);

            })
            .catch(err => {
                // Handle Error Here
                console.log('Fehler operatingpointAPI.getUnits');
                console.error(err);
            }); */

        //first get UserSettings if data : user.auth=true


        if (data.auth) {
            console.log('getUserSettings data:');
            console.log(data);
            operatingpointAPI.getUserSettings(data)
                .then(response => {
                    console.log('getUserSettings response.data:');
                    console.log(response.data);
                    /*for globals  '/api/get/users/settings/data'; //returnTotalUserData
                    return sollte:

                    $user['user_profile']
		            $user['user_settings']    !!!!! user_setting    nicht user_settings
	            	$user['units']

                    if (response.data.user_settings.length > 0) {
                        commit('setSettings', response.data);
                    }
                    */
                    /*for  globals '/api/get/users/settings';  //without units */

                    /* if (response.data.length > 0) { */
                       /*  response.data.user_settings = response.data.user_settings
                        response.data.units = response.data.units
                        response.data.user_units = response.data.user_units */

                        commit('setSettings', response.data);
                   /*  } */
                })
                .catch(err => {
                    // Handle Error Here
                    console.log('Fehler operatingpointAPI.getUserSettings');
                    console.error(err);
                    /*if not access UserSettings, get Units from DB
                   operatingpointAPI.getUnits()
                       .then(res => {
                           //ToDo units are together with settings from getUserSettings
                           console.log('operatingpoint InitLoad');
                           console.log(res);
                           commit('setDefaults', res.data);

                       })
                       .catch(function () {
                           //commit('setUnits', []);
                           console.log('Fehler operatingpointAPI.getUnits');
                           commit('resetState')
                       });
                   */
                });
            /* commit('setPressuretypeOptions', data); */
        }
        else {

            var response = await operatingpointAPI.getUnits()
            var units = response.data
            if (response.status >= 400) {
                console.log('Fehler operatingpointAPI.getUnits');
            }
            else {
                //commit('setDefaults', response.data);
                state.op.airflowunits_options = []
                state.op.pressureunits_options =[]
                state.op.pressuretype_options = []

                for (var i = 0; i < units.length; i++) {
                    if (units[i].unit_types_id == 1) {
                        state.op.airflowunits_options.push({ value: units[i].id, text: units[i].label });
                        if (units[i].is_base == true) state.op.airflowunits = units[i].id;
                    }
                    else if (units[i].unit_types_id == 2) {
                        state.op.pressureunits_options.push({ value: units[i].id, text: units[i].label });
                        if (units[i].is_base == true) state.op.pressureunits = units[i].id;
                    }
                    else if (units[i].unit_types_id == 3) {
                        state.op.pressuretype_options.push({ value: units[i].id == 10 ? 'tot' : 'stat', text: units[i].label });
                        if (units[i].is_base == true) state.op.pressuretype = units[i].id == 10 ? 'tot' : 'stat';
                    }
                }
                console.log('InitLoad units:', units)
                state.op.units = units //all units

            }

        }
    },
    resetState({ commit }) {
            commit('resetState')
    },


};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

